// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  inviteId: __t.uuid().name("invite_id"),
  brand: __t.uuid(),
  brandName: __t.string().name("brand_name"),
  brandHeroCdnPath: __t.option(__t.string()).name("brand_hero_cdn_path"),
  invitedByName: __t.string().name("invited_by_name"),
});
